import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  save: {
    description: 'settings.save-bar.save',
    defaultMessage: 'Save Changes',
    id: 'qkwr/d',
  },
  saving: {
    description: 'settings.save-bar.saving',
    defaultMessage: 'Saving...',
    id: 'Vu5iiR',
  },
});
